import { render, staticRenderFns } from "./PanchoWillies_drinkSection.vue?vue&type=template&id=9c4dd632&scoped=true"
import script from "./PanchoWillies_drinkSection.vue?vue&type=script&lang=ts"
export * from "./PanchoWillies_drinkSection.vue?vue&type=script&lang=ts"
import style0 from "./PanchoWillies_drinkSection.vue?vue&type=style&index=0&id=9c4dd632&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c4dd632",
  null
  
)

export default component.exports